<div class="header-dropdown hd" [ngClass]="{ 'header-dropdown--open': menuOpen }">
    <div class="hd__inner">
        <ng-content></ng-content>
    </div>
</div>